module.exports = __webpack_public_path__ + "static/media/plus-octagon.5f4440a2.svg";